import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = '/api';

export const attendenceApi = createApi({
  reducerPath: 'attendenceApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({

    GetAttendenceDetails: builder.query({
      query: (id) => ({
        url: `/attend/${id}`,
        method: 'GET',
      }),
      // Use 'Projects' for providesTags
      providesTags: (result, error, id) => [{ type: 'attends', id }],
    }),
    getAllAttend: builder.query({
      query: (Token) => ({
        url: '/attend',
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["attends"],
      invalidatesTags: ['attends', 'attend']
    }),
    SaveAttendence : builder.mutation({
        query: ({Token,data}) => ({
          url: '/attend',
          method: 'POST',
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          body : data,
        }),
        invalidatesTags: ['attends', 'attend']
      }),
      UpdateAttendence : builder.mutation({
        query: ({Token,data}) => ({
            url: '/attend',
            method: 'PUT',
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body : data,
          }),
          invalidatesTags: ['attends', 'attend']
      })
  }),
});

export const { useGetAttendenceDetailsQuery, useGetAllAttendQuery , useSaveAttendenceMutation , useUpdateAttendenceMutation} = attendenceApi